<div class="signin-page-wrap height-100">
  <div class="session-form-hold mb-1">
    <div class="text-center pt-8 pb-16">
      <img src="../../../../../assets/images/MT18815.gif" alt="" class="mb-05" />
    </div>
  </div>
  <div class="email-verification-page-wrap height-100">
    <div class="session-form-hold">
      <div class="text-center pt-8 pb-16">
        <h2 class="mb-1">
          <strong>Verification Email Sent!</strong>
        </h2>
        <p class="body-text">
          Please enter the six digit code included in the email to verify your new email address.
        </p>
      </div>
      <form [formGroup]="emailVerificationForm" (ngSubmit)="onSubmit()">
        <div
          class="mb-1 qtac-error-container"
          data-test="error-message-register-main"
          *ngIf="showEmailVerificationInvalid"
        >
          {{ emailVerificationErrorMessage }} Note: code will expire after 24 hours.
        </div>
        <div class="email-verification-input-container">
          <div>Email</div>
          <input
            data-test="input-email"
            class="qtac-input"
            matInput
            name="email"
            type="email"
            required
            formControlName="email"
            value=""
          />
          <ng-container *ngFor="let error of error_messages.email">
            <small
              data-test="error-email"
              *ngIf="
                formControls.email.hasError(error.type) &&
                formControls.email.touched
              "
              class="form-error-msg error-msg"
            >
              {{ error.message }}
            </small>
          </ng-container>
        </div>

        <div class="email-verification-input-container">
          <div>Confirmation Code</div>
          <input
            data-test="input-confirmation-code"
            class="qtac-input"
            matInput
            name="code"
            type="text"
            required
            formControlName="code"
            value=""
          />
          <ng-container *ngFor="let error of error_messages.code">
            <small
              data-test="error-code"
              *ngIf="
                formControls.code.hasError(error.type) &&
                formControls.code.touched
              "
              class="form-error-msg error-msg"
            >
              {{ error.message }}
            </small>
          </ng-container>
        </div>
        <div class="text-center">
          <button
            data-test="email-verification-button"
            mat-raised-button
            class="email-verification-button mb-1"
            [disabled]="emailVerificationForm.invalid"
          >
            VERIFY EMAIL
          </button>
        </div>
        <div class="text-center">
          <button
            type="button"
            data-test="verify-resend-code-button"
            mat-button
            class="email-verification-button mb-1"
            [disabled]="!formControls.email.valid"
            (click)="resendConfirmedCode()"
          >
            RESEND CODE
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
